import styled from 'styled-components';
import {device} from '@guestapp/ui/src/utils/device';

export const List = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px 0 48px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  max-height: 290px;
  overflow-y: scroll;

  @media (min-width: ${device.tablet}) {
    max-width: 384px;
    margin: 0 auto 48px;
  }
`;

export const GuestItemRow = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  padding: 16px;

  & .checkbox__box {
    svg {
      fill: white;
      color: white;
    }
  }
`;
